export default __webpack_public_path__ + "static/Jan-e1585576203114-9e0b28daa8a3be65b82ea778067ce6be.jpg";